import { dataUserFilterSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconUserFilterSolid = /*#__PURE__*/createIcon(dataUserFilterSolid)
export default IconUserFilterSolid
